const { NumberUtil } = require("../../utils");

class ShipmentPrice {
  constructor() {
    this.liabilityAmount = 0;
    this.parcelAmount = 0;
    this.amount = 0;
    this.taxAmount = 0;
    this.totalIncVatAmount = 0;
  }

  static calculateParcelWeightPrice(parcel, price) {
    const { _weight, _quantity = 1 } = parcel;
    const basePrice = price.baseRate; // Assume shop drop-off as default

    if (_weight > price.baseRateWeight) {
      const extraWeight = _weight - price.baseRateWeight;
      const extraRateUnits = Math.ceil(
        extraWeight / price.additionalRateWeight
      );
      return (basePrice + extraRateUnits * price.additionalRate) * _quantity;
    }

    return basePrice * _quantity;
  }

  static calculateShipmentPrice(shipment, price, config) {
    const shipmentPrice = new ShipmentPrice();
    if (shipment.outboundConsignment.liability) {
      shipmentPrice.liabilityAmount =
        config.insurance[shipment.outboundConsignment.liabilityValue];
    }
    const parcelPrices = shipment.outboundConsignment.parcels.map((parcel) =>
      ShipmentPrice.calculateParcelWeightPrice(parcel, price)
    );

    const parcelsTotal = parcelPrices.reduce(
      (sum, parcelPrice) => sum + parcelPrice,
      0
    );

    const collectionSurcharge = shipment.outboundConsignment.collectionDetails
      .dropAtShop
      ? 0
      : price.driverCollectionSurcharge;
    shipmentPrice.parcelAmount = parcelsTotal + collectionSurcharge;
    shipmentPrice.amount =
      shipmentPrice.parcelAmount + shipmentPrice.liabilityAmount;

    shipmentPrice.taxAmount =
      Math.round(((shipmentPrice.amount * price.vatRate) / 100) * 100) / 100;
    shipmentPrice.totalIncVatAmount =
      shipmentPrice.amount + shipmentPrice.taxAmount;

    return shipmentPrice;
  }

  getLiabilityAmount(precision) {
    return NumberUtil.preciseFloat(this.liabilityAmount, precision);
  }

  getParcelAmount(precision) {
    return NumberUtil.preciseFloat(this.parcelAmount, precision);
  }

  getAmount(precision) {
    return NumberUtil.preciseFloat(this.amount, precision);
  }

  getTaxAmount(precision) {
    return NumberUtil.preciseFloat(this.taxAmount, precision);
  }

  getTotalIncVatAmount(precision) {
    return NumberUtil.preciseFloat(this.totalIncVatAmount, precision);
  }

  toViewJSON(precision) {
    return {
      liabilityAmount: this.getLiabilityAmount(precision),
      parcelAmount: this.getParcelAmount(precision),
      amount: this.getAmount(precision),
      taxAmount: this.getTaxAmount(precision),
      totalIncVatAmount: this.getTotalIncVatAmount(precision),
    };
  }
}

module.exports = ShipmentPrice;
